import {
    Box, Button, CardContent, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup,
    TextField, Typography
} from '@material-ui/core';
import {
    ANAO, AORIGEM_OSMANUT_VEICULO_AUTOMATICA, AORIGEM_OSMANUT_VEICULO_IMPORTADO, AORIGEM_OSMANUT_VEICULO_MANUAL,
    ASIM, ASITUACAO_OSMANUT_VEICULO_ABERTA, ATIPO_OSMANUT_CORRETIVA, ATIPO_OSMANUT_PREVENTIVA
} from '../../../consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import ComboPadrao from 'views/Components/ComboPadrao';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { getSituacaoOsManut, getSituacaoOsManutColor, isInvalidSelect } from 'lib/configUtils';

class OsManutVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            osmanutveiculo: {
                codosmanutveiculo: '',
                tipoos: ATIPO_OSMANUT_CORRETIVA,
                situacao: ASITUACAO_OSMANUT_VEICULO_ABERTA,
                origem: AORIGEM_OSMANUT_VEICULO_MANUAL,
                dataemissao: '',
                hora: '',
                socorro: '',
                codveiculo: '',
                hodometro: '',
                codfuncionariosolicitou: '',
                reclamacao: ''
            },
            isLoadingOS: true,
            errors: {},
            veiculos: [],
            motoristas: [],
            isNewRecord: false,
            isView: false,
            schema: {
                dataemissao: {
                    presence: { allowEmpty: false, message: 'Data obrigatória' },
                    format: {
                        pattern: /^\d{4}-\d{2}-\d{2}$/,
                        message: 'Data inválida'
                    }
                },
                codveiculo: {
                    presence: { allowEmpty: false, message: 'Veículo obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                hodometro: {
                    presence: { allowEmpty: false, message: 'Hodômetro inválido' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codfuncionariosolicitou: {
                    presence: { allowEmpty: false, message: 'Motorista obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                reclamacao: {
                    presence: { allowEmpty: false, message: 'Reclamação obrigatória' },
                    length: { maximum: 100 },
                    type: 'string'
                }
            }
        }
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const { osmanutveiculo } = this.state;
        const currentPath = location.pathname;

        if (id >= 0) {
            try {
                const response = await api.get(`/osmanutveiculo/${id}`);
                const dados = (response.data && response.data.data && response.data.data[0]) ? response.data.data[0] : {};

                // "let params" somente quando é preciso passar filtro específico de uma tabela
                let paramsveiculo = `?page=1&limit=500&veiculoproprio=S`;
                let paramsmotorista = `?page=1&limit=500&funcionario=S`;

                const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
                this.setState({
                    veiculos: (veiculos.data?.data || []).map(item => ({
                        ...item,
                        placanroveiculo: item.placa && item.nroveiculo ? `${item.placa} [${item.nroveiculo}]` : (item.nroveiculo || '')
                    }))
                });

                const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
                this.setState({ motoristas: motoristas.data });

                console.log('DADOS RECEBIDOS DO BACKEND:', JSON.stringify(dados, null, 2));

                this.setState({
                    osmanutveiculo: {
                        ...dados,
                        socorro: dados.socorro || ANAO, // garante default "N"
                        hora: dados.hora
                    },
                    tipoos: dados.tipoos ? String(dados.tipoos) : String(ATIPO_OSMANUT_CORRETIVA),
                    reclamacao: dados.reclamacao || '',
                    isNewRecord: false,
                    isLoadingOS: false,
                    isView: (currentPath.includes('/view'))
                });
            } catch (error) {
                console.error('Erro ao carregar:', error);
            }
        }

        else if (id === 'novo') {
            const hoje = new Date().toISOString().substring(0, 10);
            const agora = new Date().toTimeString().substring(0, 5);

            this.setState({
                isNewRecord: true,
                isLoadingOS: false,
                osmanutveiculo: {
                    ...osmanutveiculo,
                    reclamacao: '',
                    tipoos: 2,
                    situacao: ASITUACAO_OSMANUT_VEICULO_ABERTA,
                    dataemissao: hoje,
                    hora: agora,
                    hodometro: 0
                }
            });

            // "let params" somente quando é preciso passar filtro específico de uma tabela
            let paramsveiculo = `?page=1&limit=500&veiculoproprio=S`;
            let paramsmotorista = `?page=1&limit=500&funcionario=S`;

            const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
            this.setState({
                veiculos: (veiculos.data?.data || []).map(item => ({
                    ...item,
                    placanroveiculo: item.placa && item.nroveiculo ? `${item.placa} [${item.nroveiculo}]` : (item.nroveiculo || '')
                }))
            });

            const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
            this.setState({ motoristas: motoristas.data });
        }
    };

    /* Evento on change componentes */
    OnChange = (event) => {
        const { name, value, type, checked } = event.target;

        // não converter para Uppercase
        if (name === 'reclamacao') {
            this.setState(prevState => ({
                osmanutveiculo: {
                    ...prevState.osmanutveiculo,
                    [name]: value
                }
            }));
            return;
        }

        let adjustedValue;

        // ajuste de campos
        if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            osmanutveiculo: {
                ...prevState.osmanutveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Atualiza dados de OS existente - post */
    handleUpdateOsManutVeiculo = async () => {
        const { osmanutveiculo } = this.state;
        try {
            const response = await api.put(`/osmanutveiculo/${osmanutveiculo.codosmanutveiculo}`, osmanutveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/osmanutveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }

        this.setState(prevState => ({
            osmanutveiculo: {
                ...prevState.osmanutveiculo,
                situacao: prevState.osmanutveiculo.situacao
            }
        }));
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { osmanutveiculo, isNewRecord } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        // validação extra para ComboPadrao obrigatório
        const comboFields = [
            {
                field: 'codveiculo',
                message: 'Selecione um veículo válido'
            },
            {
                field: 'codfuncionariosolicitou',
                message: 'Selecione um motorista válido'
            }
        ];

        const comboErrors = {};

        comboFields.forEach(({ field, message }) => {
            if (isInvalidSelect(osmanutveiculo[field])) {
                comboErrors[field] = message;
            }
        });

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            const formData = new FormData();

            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando há campos do tipo BLOB
            formData.append('codusuarioregistrou', Number(codusuarioregistrou));
            formData.append('dataemissao', osmanutveiculo.dataemissao || '');
            formData.append('hora', osmanutveiculo.hora || '');
            formData.append('codveiculo', osmanutveiculo.codveiculo || '');
            formData.append('hodometro', osmanutveiculo.hodometro || '');
            formData.append('tipoos', osmanutveiculo.tipoos || '');
            formData.append('situacao', osmanutveiculo.situacao || null);
            formData.append('dataregistro', osmanutveiculo.dataregistro || '');
            formData.append('horaregistro', osmanutveiculo.horaregistro || '');
            formData.append('reclamacao', osmanutveiculo.reclamacao || '');
            formData.append('codfuncionariosolicitou', osmanutveiculo.codfuncionariosolicitou || '');
            formData.append('textoencerramento', osmanutveiculo.textoencerramento || '');
            formData.append('codrequisicao', osmanutveiculo.codrequisicao || '');
            formData.append('codusuarioencerrou', osmanutveiculo.codusuarioencerrou || '');
            formData.append('datahoraencerramento', osmanutveiculo.datahoraencerramento || '');
            formData.append('origem', Number(osmanutveiculo.origem ?? AORIGEM_OSMANUT_VEICULO_MANUAL));
            formData.append('codusuariocancelou', osmanutveiculo.codusuariocancelou || '');
            formData.append('datahoracancelamento', osmanutveiculo.datahoracancelamento || '');
            formData.append('motivocancelamento', osmanutveiculo.motivocancelamento || '');
            formData.append('datahorareabertura', osmanutveiculo.datahorareabertura || '');
            formData.append('codusuarioreabriu', osmanutveiculo.codusuarioreabriu || '');
            formData.append('socorro', osmanutveiculo.socorro || '');

            if (isNewRecord) {
                await api.post('/osmanutveiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.put(`/osmanutveiculo/${osmanutveiculo.codosmanutveiculo}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            if (this.props.loadOssManutVeiculos) this.props.loadOssManutVeiculos();
            this.props.history.push('/frotas/osmanutveiculo');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            const backendMsg = error.response?.data?.error || error.response?.data?.message || error.message || '';

            // tenta extrair o último hodômetro do texto
            const matchUltimo = backendMsg.match(/último\s+registrado\s*\((\d+)\)/i);
            const ultimoHodometro = matchUltimo ? matchUltimo[1] : null;

            if (ultimoHodometro) {
                this.handleOpenAlert(
                    `ERRO! O hodômetro deve ser igual ou superior ao último hodômetro (${ultimoHodometro}) do veículo!`
                );
            } else {
                this.handleOpenAlert('Erro ao salvar!');
            }
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/osmanutveiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { osmanutveiculo, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'dataemissao',
            'codveiculo',
            'hodometro',
            'codfuncionariosolicitou',
            'reclamacao'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, osmanutveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        });

        // hodômetro não pode ser 0 (zero)
        if (osmanutveiculo.hodometro === 0 || osmanutveiculo.hodometro === '0') {
            errors.hodometro = 'Hodômetro inválido';
        }

        return errors;
    };

    /* Insere nova OS */
    handleInsertOsManutVeiculo = async () => {
        const { osmanutveiculo } = this.state;
        osmanutveiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/osmanutveiculo`, osmanutveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/osmanutveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Método para aceitar somente dígitos */
    handleNumericChange = (e) => {
        const { name, value } = e.target;
        const onlyDigits = value.replace(/\D/g, '');
        this.setState(prevState => ({
            osmanutveiculo: {
                ...prevState.osmanutveiculo,
                [name]: onlyDigits
            }
        }));
    };

    render() {
        const {
            isNewRecord,
            osmanutveiculo,
            veiculos,
            motoristas,
            errors,
            isView,
            openAlert,
            messageAlert,
            isLoadingOS
        } = this.state;
        const situacaoTexto = isNewRecord ? 'nova' : getSituacaoOsManut(osmanutveiculo?.situacao);
        const situacaoCor = isNewRecord ? '#3a913f' : getSituacaoOsManutColor(osmanutveiculo?.situacao);
        const origemTexto = (() => {
            const origem = Number(osmanutveiculo.origem ?? AORIGEM_OSMANUT_VEICULO_MANUAL);
            if (origem === AORIGEM_OSMANUT_VEICULO_IMPORTADO) return 'importado';
            if (origem === AORIGEM_OSMANUT_VEICULO_AUTOMATICA) return 'automática';
            return 'manual';
        })();

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{
                            width: '100%',
                            marginBottom: 10,
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                        >
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                OS {osmanutveiculo.codosmanutveiculo}
                            </Typography>

                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                {!isLoadingOS && (
                                    <span
                                        style={{
                                            marginLeft: 16,
                                            padding: '5px 12px',
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            backgroundColor: '#f2f2f2',
                                            border: '1px solid #d0d0d0',
                                            borderRadius: 12,
                                            color: situacaoCor,
                                            display: 'inline-flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Situação: {situacaoTexto}
                                    </span>
                                )}
                            </Typography>
                        </Box>

                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            {!isLoadingOS && (
                                <span
                                    style={{
                                        padding: '5px 12px',
                                        fontSize: '1rem',
                                        fontWeight: 600,
                                        backgroundColor: '#f2f2f2',
                                        border: '1px solid #d0d0d0',
                                        borderRadius: 12,
                                        color: '#616161',
                                        display: 'inline-flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    Origem: {origemTexto}
                                </span>
                            )}
                        </Typography>
                    </Box>

                    <br />

                    {/* BOX PRIMEIRA LINHA */}
                    <Box
                        display="flex"
                        alignItems="center"
                        style={{
                            marginTop: 8,
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <FormControl
                            component="fieldset"
                            disabled={isView}
                            style={{
                                marginRight: '1rem',
                                flex: '1 1 260px',
                                minWidth: 240
                            }}
                        >
                            <FormLabel component="legend">
                                Tipo OS
                            </FormLabel>

                            <RadioGroup
                                row
                                name="tipoos"
                                value={osmanutveiculo.tipoos}
                                onChange={this.OnChange}
                            >
                                <FormControlLabel
                                    value={ATIPO_OSMANUT_PREVENTIVA}
                                    label={<span>Preventiva</span>}
                                    control={
                                        <Radio
                                            size="small"
                                            color="primary"
                                            disabled
                                        />
                                    }
                                />

                                <FormControlLabel
                                    value={ATIPO_OSMANUT_CORRETIVA}
                                    label={<span>Corretiva</span>}
                                    control={
                                        <Radio
                                            size="small"
                                            color="primary"
                                        />
                                    }
                                />
                            </RadioGroup>
                        </FormControl>

                        <TextField
                            label="Data emissão"
                            name="dataemissao"
                            onChange={this.OnChange}
                            type="date"
                            value={osmanutveiculo.dataemissao ? osmanutveiculo.dataemissao.substring(0, 10) : ''}
                            variant="outlined"
                            disabled={isView || isNewRecord}
                            helperText={errors.dataemissao || ''}
                            error={!!errors.dataemissao}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                marginRight: '2rem',
                                minWidth: 150,
                                flex: '0 1 150px'
                            }}
                        />

                        <TextField
                            label="Hora"
                            name="hora"
                            onChange={this.OnChange}
                            type="time"
                            value={osmanutveiculo.hora ?? '00:00'}
                            variant="standard"
                            disabled={isView}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                marginRight: '2rem',
                                minWidth: 90,
                                flex: '0 1 90px'
                            }}
                        />

                        <FormControlLabel
                            label="Socorro"
                            control={
                                <Checkbox
                                    checked={(osmanutveiculo.socorro === ASIM)}
                                    name="socorro"
                                    onChange={this.OnChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    {/* BOX SEGUNDA LINHA */}
                    <Box
                        display="flex"
                        style={{
                            marginTop: 8,
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '1 1 320px',
                                minWidth: 240
                            }}
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={osmanutveiculo.codveiculo}
                                onChange={this.OnChange}
                                fieldId={'codveiculo'}
                                listItems={veiculos}
                                fieldDescription={'placanroveiculo'}
                                helperText={errors.codveiculo || ''}
                                error={!!errors.codveiculo}
                            />
                        </FormControl>

                        <TextField
                            label="Hodômetro"
                            name="hodometro"
                            value={osmanutveiculo.hodometro !== '' && osmanutveiculo.hodometro !== null && osmanutveiculo.hodometro !== undefined ? osmanutveiculo.hodometro : ''}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView || !isNewRecord}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                            helperText={errors.hodometro || ''}
                            error={!!errors.hodometro}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 150,
                                backgroundColor: (isView || !isNewRecord) ? '#f2f2f2' : 'transparent'
                            }}
                        />
                    </Box>

                    <br />

                    {/* BOX TERCEIRA LINHA */}
                    <Box marginTop="8px">
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{ width: '100%' }}
                        >
                            <ComboPadrao
                                name={'codfuncionariosolicitou'}
                                label={'Solicitado por (motorista):'}
                                value={osmanutveiculo.codfuncionariosolicitou}
                                onChange={this.OnChange}
                                fieldId={'codfornecedor'}
                                listItems={motoristas}
                                fieldDescription={'fantasia'}
                                helperText={errors.codfuncionariosolicitou || ''}
                                error={!!errors.codfuncionariosolicitou}
                            />
                        </FormControl>
                    </Box>

                    {/* CAMPO BLOB RECLAMAÇÃO */}
                    <Box marginTop="8px">
                        <Typography
                            component="p"
                            variant="body2"
                            color={errors.reclamacao ? 'error' : 'textSecondary'}
                        >
                            Reclamação
                        </Typography>

                        <FormGroup>
                            <textarea
                                id="reclamacao"
                                name="reclamacao"
                                onChange={this.OnChange}
                                value={osmanutveiculo.reclamacao}
                                disabled={isView}
                                style={{
                                    width: '100%',
                                    height: 160,
                                    padding: 8,
                                    boxSizing: 'border-box',
                                    border: errors.reclamacao ? '1px solid #f44336' : '1px solid #ccc',
                                    borderRadius: 4,
                                    fontFamily: 'Calibri, sans-serif',
                                    outline: 'none'
                                }}
                            />

                            {errors.reclamacao && (
                                <Typography
                                    variant="caption"
                                    style={{
                                        color: '#f44336',
                                        marginTop: 4,
                                        marginLeft: 2
                                    }}
                                >
                                    {errors.reclamacao}
                                </Typography>
                            )}
                        </FormGroup>
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10,
                            marginTop: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent >

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default OsManutVeiculoForm;